import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TRADE_DEMOS } from "@/data/tradeDemos";

export default function TradeDemos() {
  const trades = Object.values(TRADE_DEMOS);
  return (
    <section id="trades" data-testid="trade-demos-section" className="py-28 lg:py-36 bg-surface/30 border-y gold-border-subtle">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">Interactive Website Showcase</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#F8F6F0] tracking-tight max-w-2xl">
            See what we'd build for <span className="gold-text italic">your exact trade.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trades.map((t, i) => (
            <motion.div
              key={t.slug}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            >
              <Link
                to={`/trades/${t.slug}`}
                data-testid={`trade-card-${t.slug}`}
                className="group block rounded-2xl border gold-border-subtle bg-surface/60 overflow-hidden hover:border-gold/40 transition-colors duration-500"
              >
                <div className="relative h-44 overflow-hidden">
                  <img src={t.image} alt={t.trade} className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-serif text-xl text-[#F8F6F0]">{t.trade}</h3>
                    <ArrowUpRight size={17} className="text-gold opacity-0 group-hover:opacity-100 transition-opacity duration-300 shrink-0" />
                  </div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-2">Compare 3 packages →</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
